import { useEffect, useState } from "react";
import "./PurchasePopup.css";
import { useNavigate } from "react-router-dom";

const cities = ["Delhi", "Gurgaon", "Mumbai", "Chennai", "Bangalore", "Pune"];
const times = [
  "30 minutes",
  "25 minutes",
  "20 minutes",
  "10 minutes",
  "15 minutes",
];

export default function PurchasePopup({ products }) {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [product, setProduct] = useState(null);
  const [city, setCity] = useState("");
  const [time, setTime] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      // Random product
      const randomProduct =
        products[Math.floor(Math.random() * products.length)];

      // Random city
      const randomCity = cities[Math.floor(Math.random() * cities.length)];

      // Random time
      const randomTime = times[Math.floor(Math.random() * times.length)];

      setProduct(randomProduct);
      setCity(randomCity);
      setTime(randomTime);
      setShow(true);

      // Hide after 5 sec
      setTimeout(() => {
        setShow(false);
      }, 8000);
    }, 40000); // every 30 minutes (60*30*1000)

    return () => clearInterval(interval);
  }, [products]);

  if (!show || !product) return null;

  return (
    <div
      className="purchase-popup shadow"
      onClick={() => navigate(`/products/${product.id}`)}
      style={{ cursor: "pointer" }}
    >
      <div className="d-flex align-items-start gap-2">
        {/* Product Image */}
        <img src={product.image} alt={product.title} className="popup-img" />

        {/* Content */}
        <div>
          <p className="popup-text mb-1">
            Someone in <strong>{city}</strong> purchased a
          </p>

          <strong className="popup-title">{product.title}</strong>

          <p className="time-text">About {time} ago</p>
        </div>
      </div>
    </div>
  );
}
